import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { Content } from '../../../infrastructure/content';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';

const TermsAndConditions = () => (
  <Content>
    {({
      termsAndConditions = '',
      wishToApply,
      readAndAcceptTC,
      receivedFSCSInfoSheet,
      authorizeToUndertakeNecessarySearches,
      termsAndConditionsSubHeader1 = '',
      termsAndConditionsSubHeader2 = '',
      businessApprovedText,
      authorisedSignatoryTermsText,
      primaryApplicantTermsText,
      businessConstitutionalTermsText,
      fairProcessingTermsText,
      bankToUndertakeTermsText,
      authoriseTheBankToSearch,
      corporateAdminTermsText = '',
      readAndAcceptTCText1 = '',
      readAndAcceptTCText2 = '',
      termsAndConditionsSubHeader3 = '',
      termsText1 = '',
      termsTextBank = '',
      termsAndConditionsBusiness = '',
      termsAndConditionsPrimaryApplicant = ''
    }) => (
      <StandardBody>
        <SectionHeading>{termsAndConditions}</SectionHeading>
        <p>
          <b>{termsTextBank}</b>
          {termsText1}
        </p>
        <p>
          <b>{termsAndConditionsBusiness}</b>
          {termsAndConditionsSubHeader1}
        </p>
        <p>
          <b>{termsAndConditionsPrimaryApplicant}</b>
          {termsAndConditionsSubHeader3}
        </p>
        <SectionHeading>{termsAndConditionsSubHeader2}</SectionHeading>
        <BulletList
          items={[
            wishToApply,
            businessApprovedText,
            <span>
              {readAndAcceptTC}
              <div>{readAndAcceptTCText1}</div>
              <div>{readAndAcceptTCText2}</div>
            </span>,
            authorizeToUndertakeNecessarySearches,
            authorisedSignatoryTermsText,
            corporateAdminTermsText,
            primaryApplicantTermsText,
            businessConstitutionalTermsText,
            receivedFSCSInfoSheet,
            fairProcessingTermsText,
            bankToUndertakeTermsText,
            authoriseTheBankToSearch
          ]}
        />
      </StandardBody>
    )}
  </Content>
);

export default TermsAndConditions;
